import { render, staticRenderFns } from "./SystemComponentsComponent.vue?vue&type=template&id=7354d66f&"
import script from "./SystemComponentsComponent.vue?vue&type=script&lang=js&"
export * from "./SystemComponentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports